(() => {
  const pending = new WeakMap();
  const load = container => {
    const template = pending.get(container);
    if (!template) return;
    template.replaceWith(template.content.cloneNode(true));
    pending.delete(container);
    observer?.unobserve(container);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) load(entry.target);
  }, { rootMargin: '300px' }) : null;
  const init = root => {
    root.querySelectorAll('template[data-rnr-deferred-images]').forEach(template => {
      const container = template.parentElement;
      if (pending.has(container)) return;
      pending.set(container, template);
      if (observer) observer.observe(container);
      else load(container);
      container.addEventListener('pointerenter', () => load(container), { once: true });
      container.addEventListener('focusin', () => load(container), { once: true });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches('template[data-rnr-deferred-images]')) init(node.parentElement);
      else init(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
